import { Field, FieldError, FieldLabel } from "@/ds/shadcn/components/ui/field";
import { Input } from "@/ds/shadcn/components/ui/input";
import { useFieldContext } from "@/lib/form/useAppForm";
import type React from "react";
import { useMemo, type FC } from "react";

export interface TextFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
	ref?: React.Ref<HTMLInputElement>;
	label: string;
	trailing?: React.ReactNode;
}

export const TextField: FC<TextFieldProps> = props => {
	const {
		label,
		trailing
	} = props;

	const field = useFieldContext<string>();

	const error = useMemo(() => {
		if (field.state.meta.errors.length < 1 || !field.state.meta.isBlurred || !field.state.meta.isDirty) {
			return null;
		}

		return field.state.meta.errors[0];
	}, [field.state.meta.errors, field.state.meta.isBlurred, field.state.meta.isDirty]);

	return (
		<Field data-invalid={!!error}>
			{
				!trailing
					? <FieldLabel htmlFor={field.name}>{label}</FieldLabel>
					: (
						<div className="flex items-center justify-between gap-2">
							<FieldLabel htmlFor={field.name}>{label}</FieldLabel>
							{trailing}
						</div>
					)
			}

			<Input
				id={field.name}
				aria-invalid={!!error}
				disabled={field.form.state.isSubmitting}
				value={field.state.value}
				onChange={e => field.handleChange(e.target.value)}
				onBlur={() => field.handleBlur()}
				{...props} />

			{
				error && <FieldError>{error.message}</FieldError>
			}
		</Field>
	);
};
